// Text of the sports section (staff side). Arabic only.
export const sportStrings = {
  ar: {
    navTitle: "الرياضة",
    title: "⚽ الرياضة · كرة القدم",
    loading: "جارٍ التحميل...",
    loadError: "تعذّر تحميل البيانات",
    saved: "تم الحفظ",
    removed: "تمت الإزالة",
    save: "حفظ",
    cancel: "إلغاء",
    edit: "تعديل",
    remove: "إزالة",
    close: "إغلاق",
    tabs: {
      players: "اللاعبون",
      lessons: "مواعيد الدروس",
      attendance: "الحضور والغياب",
      notices: "الإعلانات",
      settings: "إعدادات الإحصائيات",
    },
    notices: {
      new: "إعلان جديد للاعبين",
      title: "العنوان",
      body: "النص",
      audience: "إلى",
      everyone: "كل اللاعبين",
      expiresOn: "يظهر حتى (اختياري)",
      pushHint: "يصل الإعلان إلى هواتف اللاعبين الذين فعّلوا التذكير، ويظهر في موقع الرياضة.",
      post: "نشر",
      posted: "تم نشر الإعلان",
      titleRequired: "عنوان الإعلان مطلوب",
      empty: "لا توجد إعلانات بعد",
      delete: "حذف",
      deleteTitle: "حذف إعلان",
      deleteConfirm: "هل تريد حذف هذا الإعلان؟ سيختفي من موقع الرياضة.",
      deleteOk: "حذف",
      deleted: "تم حذف الإعلان",
      until: "حتى",
      expired: "انتهى في",
    },
    players: {
      signOut: "تسجيل الخروج",
      signOutTitle: "تسجيل خروج اللاعب",
      signOutConfirm: "سيُطلب منه تسجيل الدخول من جديد على كل هاتف. متابعة؟",
      signedOut: "تم تسجيل خروجه من موقع الرياضة",
      loginCard: "بطاقة الدخول",
      loginCardAgain: "بطاقة دخول جديدة",
      loginCardAgainConfirm: "البطاقة السابقة لن تعمل بعد الآن. الهواتف المتصلة تبقى متصلة. متابعة؟",
      loginCardHow: "امسح الرمز بكاميرا الهاتف: يفتح موقع الرياضة ويدخل مباشرة.",
      loginCardKeep: "احتفظ بالبطاقة ولا تشاركها: من يمسحها يدخل باسمك.",
      loginCardPrint: "طباعة",
      loginCardSend: "إرسال",
      loginCardCopied: "نُسخ الرابط وحُفظت صورة البطاقة",
      loginCardSaved: "حُفظت صورة البطاقة، يمكنك طباعتها من الصور",
      loginCardFailed: "تعذر الإرسال، حاول مرة أخرى",
      search: "ابحث بالاسم أو رقم الهوية",
      searchLabel: "بحث في اللاعبين",
      allLessons: "كل الدروس",
      lessonFilter: "الدرس",
      age: "العمر",
      ageFilter: "العمر",
      allAges: "كل الأعمار",
      allGenders: "الجنسان",
      gender: "الجنس",
      male: "ذكر",
      female: "أنثى",
      add: "+ إضافة لاعب من الطلاب",
      count: "لاعبًا",
      empty: "لا يوجد لاعبون",
      name: "الاسم",
      tz: "رقم الهوية",
      photoAlt: "صورة اللاعب",
      openCard: "عرض بطاقة اللاعب",
      lessons: "الدروس",
      jersey: "القميص",
      position: "المركز",
      attendance: "الحضور",
      actions: "الإجراءات",
      absences: "غياب",
      lates: "تأخير",
      noAttendance: "—",
      none: "—",
      increase: "زيادة",
      decrease: "إنقاص",
      removeTitle: "إزالة لاعب",
      removeConfirm: "هل تريد إزالة هذا اللاعب؟ سيُحذف من دروسه، وتبقى سجلات حضوره.",
      removeOk: "إزالة",
      editTitle: "تعديل اللاعب",
    },
    dialog: {
      title: "إضافة لاعب من الطلاب",
      search: "ابحث بالاسم أو رقم الهوية",
      loadingStudents: "جارٍ تحميل الطلاب...",
      noResults: "لا توجد نتائج",
      alreadyPlayer: "لاعب بالفعل",
      tz: "رقم الهوية",
      photoAlt: "صورة الطالب",
      pick: "اختيار",
      change: "تغيير الطالب",
      jersey: "رقم القميص",
      position: "المركز",
      lessons: "الدروس",
      noLessons: "لا توجد دروس بعد",
    },
    lessons: {
      add: "+ إضافة موعد",
      addTitle: "إضافة موعد",
      editTitle: "تعديل الموعد",
      removeConfirm: "هل تريد إزالة هذا الطالب من الموعد؟",
      manage: "اللاعبون",
      rosterTitle: "لاعبو الموعد",
      rosterEmpty: "لا يوجد لاعبون في هذا الموعد",
      addStudent: "+ إضافة طالب",
      addStudentTitle: "إضافة طالب إلى الموعد",
      alreadyInLesson: "في الموعد بالفعل",
      added: "تمت إضافة الطالب إلى الموعد",
      rosterRemoved: "تمت إزالة الطالب من الموعد",
      removePlayer: "إزالة",
      back: "رجوع",
      day: "اليوم",
      start: "من",
      end: "إلى",
      players: "اللاعبون",
      empty: "لا توجد مواعيد دروس",
      deleteTitle: "حذف موعد",
      deleteConfirm: "سيتم حذف هذا الموعد وسجلات حضوره. لا يمكن التراجع عن هذا الإجراء.",
      deleteOk: "حذف",
      deleted: "تم حذف الموعد",
    },
    card: {
      title: "بطاقة اللاعب",
      flipHint: "اضغط على البطاقة لقلبها",
      attendance: "الحضور",
      lates: "التأخير",
      brandFull: "تمهيد - رياضة",
      birthDate: "تاريخ الميلاد",
      idNumber: "رقم الهوية",
      jerseyNumber: "رقم القميص",
      mentor: "مرشد تربوي",
    },
    attendance: {
      noToday: "لا يوجد درس اليوم",
      noLessons: "لا توجد دروس بعد. أضف موعدًا من تبويب «مواعيد الدروس».",
      lesson: "الدرس",
      date: "التاريخ",
      pickLesson: "اختر درسًا",
      loading: "جارٍ تحميل الحضور...",
      noPlayers: "لا يوجد لاعبون في هذا الدرس",
      player: "اللاعب",
      status: "الحالة",
      present: "حاضر",
      absent: "غائب",
      late: "متأخر",
      allPresent: "الكل: حاضر",
      allAbsent: "الكل: غائب",
      allLate: "الكل: متأخر",
      save: "حفظ الحضور",
      saved: "تم حفظ الحضور",
      unsaved: "توجد تغييرات لم تُحفظ",
      unmarked: "غير مسجّل",
      readOnly: "عرض فقط: تسجيل الحضور للمدرّب أو مدير الرياضة",
      nothingToSave: "حدّد حالة لاعب واحد على الأقل",
    },
    settings: {
      intro: "حتى 4 إحصائيات تُسجَّل لكل لاعب.",
      label: "اسم الإحصائية",
      add: "+ إضافة إحصائية",
      up: "نقل لأعلى",
      down: "نقل لأسفل",
      delete: "حذف",
      deleteTitle: "حذف إحصائية",
      deleteConfirm: "سيتم حذف قيم هذه الإحصائية من كل اللاعبين",
      deleteOk: "حذف",
      empty: "لا توجد إحصائيات بعد",
    },
    validation: {
      tooManyStats: "الحد الأقصى 4 إحصائيات",
      blankStat: "اسم الإحصائية مطلوب",
      jersey: "رقم القميص يجب أن يكون عددًا من 1 إلى 99",
      studentRequired: "اختر طالبًا",
      timesRequired: "حدّد وقت البداية ووقت النهاية",
      endAfterStart: "وقت النهاية يجب أن يكون بعد وقت البداية",
    },
  },
};
